import { createReducer } from '@reduxjs/toolkit';

import { ACTIONS } from '../../constants';
import { ActionsStateType } from '../../types';
import { fetchActionsInfo, setActionsLoading } from '../actions/actions';

const initialState: ActionsStateType = {
  data: {
    isSale: false,
    isPurchase: false,
    isCredit: false,
    isHybridIssue: false,
    isFinanceIssue: false,
    isOperatorActions: false,
  },
  loading: {
    info: false,
  },
};

const actionsReducer = createReducer(initialState, (builder) => {
  builder.addCase(setActionsLoading, (state, action) => {
    state.loading[action.payload.type] = action.payload.value;
  });

  builder.addCase(fetchActionsInfo.fulfilled, (state, action) => {
    if (action.payload?.length) {
      state.data = {
        isSale: action.payload.includes(ACTIONS.SALE),
        isPurchase: action.payload.includes(ACTIONS.PURCHASE),
        isCredit: action.payload.includes(ACTIONS.CREDIT),
        isHybridIssue: action.payload.includes(ACTIONS.HYBRID_ISSUE),
        isFinanceIssue: action.payload.includes(ACTIONS.FINANCE_ISSUE),
        isOperatorActions: action.payload.includes(ACTIONS.OPERATOR_ACTIONS),
      };
    }
  });
});

export default actionsReducer;
